import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {VStack} from "native-base";
import {Radio} from "antd";
import {t} from "../../../../../../services/i18n";
import AdvanceSelect from "../../../../../common/AdvanceSelect";
import FormInput from "../../../../../common/FormInput";
import {checkRequired} from "../../../../../../services/stepperService";
import {APPOINTMENT, APPOINTMENT_MANAGEMENT_FORM} from "../../../../../../services/ConstHelper";
import {orderBy} from "lodash";
import {getCategoriesByTypes} from "../../../../../../redux/ScheduleSlice";

const DISPLAY_MODE_NONE = 'none';
const DISPLAY_MODE_ALL = 'all';
const DISPLAY_MODE_SPECIFIC = 'specific';

const FlowFormManage = (props) => {
    const { values, setFieldValue, errors, touched, validationObject } = props;
    const dispatch = useDispatch();
    const appointmentFormSettings = useSelector(state => state.box.box.settings?.[APPOINTMENT_MANAGEMENT_FORM]);
    const boxCategoriesByType = useSelector(state => state.schedule.eventTypes.data);
    const [selectedCategories, setSelectedCategories] = useState(null);

    useEffect(() => {
        if (!boxCategoriesByType) dispatch(getCategoriesByTypes(true));
    }, [boxCategoriesByType, dispatch]);

    const appointmentCategoryOptions = useMemo(() => {
        if (!boxCategoriesByType?.[APPOINTMENT]) return null;
        return orderBy(
            boxCategoriesByType[APPOINTMENT].filter(item => !!item.active).map(item => ({...item, value: item.id, label: item.name})),
            ['label'],
            ['asc']
        );
    }, [boxCategoriesByType]);

    useEffect(() => {
        if (appointmentCategoryOptions && !selectedCategories && values.appointmentType?.box_categories?.length) {
            setSelectedCategories(appointmentCategoryOptions.filter(item => values.appointmentType.box_categories.includes(item.id)));
        }
    }, [appointmentCategoryOptions, values.appointmentType?.box_categories]);

    useEffect(() => {
        if (selectedCategories) {
            setFieldValue('appointmentType.box_categories', selectedCategories.map(item => item.id));
        }
    }, [selectedCategories]);

    const displayMode = values.appointmentType?.displayMode ?? DISPLAY_MODE_NONE;

    return (
        <VStack>
            <FormInput label={t('flow-form-manage-display-label')} width={'100%'} containerProps={{mb: '12px'}}>
                <Radio.Group value={displayMode} onChange={(e) => {
                    const mode = e.target.value;
                    setFieldValue('appointmentType.displayMode', mode);
                    if (mode !== DISPLAY_MODE_SPECIFIC) setFieldValue('appointmentType.box_categories', []);
                }}>
                    <VStack space={'0.5rem'}>
                        <Radio value={DISPLAY_MODE_NONE}>{t('flow-form-manage-display-none')}</Radio>
                        <Radio value={DISPLAY_MODE_ALL}>{t('flow-form-manage-display-all')}</Radio>
                        <Radio value={DISPLAY_MODE_SPECIFIC}>{t('flow-form-manage-display-specific')}</Radio>
                    </VStack>
                </Radio.Group>
            </FormInput>
            {displayMode === DISPLAY_MODE_SPECIFIC && appointmentCategoryOptions && (
                <FormInput label={t('appointmentLabelName') + checkRequired('appointmentType.box_categories', validationObject)} width={'100%'} error={(touched?.appointmentType?.box_categories && errors?.appointmentType?.box_categories) ? errors.appointmentType.box_categories : null}>
                    <AdvanceSelect options={appointmentCategoryOptions}
                                   initValue={selectedCategories}
                                   isClearable={true}
                                   isMulti={true}
                                   closeMenuOnSelect={false}
                                   onChange={(res) => setSelectedCategories(res)}
                                   isError={touched?.appointmentType?.box_categories && errors?.appointmentType?.box_categories}
                    />
                </FormInput>
            )}
        </VStack>
    );
};

export default FlowFormManage;
export {DISPLAY_MODE_NONE, DISPLAY_MODE_ALL, DISPLAY_MODE_SPECIFIC};
